import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import { interaction___more02 } from '@lsg/icons';
import React from 'react';
import { uniqueId } from '../../utils/DomUtils.js';
import { ActionFlyoutPresentation } from '../ActionFlyout/ActionFlyoutPresentation.js';
import { ActionFlyoutItemWrapper } from '../ActionFlyoutItem/ActionFlyoutItemWrapper.js';
import { IconLinkPresentation } from '../IconLink/IconLinkPresentation.js';

var CardsMenu = function CardsMenu(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? uniqueId("menu-id") : _ref$id,
    _ref$buttonId = _ref.buttonId,
    buttonId = _ref$buttonId === void 0 ? uniqueId("action-flyout-button") : _ref$buttonId,
    menuCallbacks = _ref.menuCallbacks,
    navigationTree = _ref.navigationTree,
    onMouseHoverChange = _ref.onMouseHoverChange,
    onKeyboardFocusChange = _ref.onKeyboardFocusChange,
    hasMouseHover = _ref.hasMouseHover,
    hasKeyboardFocus = _ref.hasKeyboardFocus,
    disabled = _ref.disabled;
  var _menuCallbacks = _slicedToArray(menuCallbacks, 4),
    _menuCallbacks$ = _menuCallbacks[0],
    open = _menuCallbacks$.open,
    focussedIndex = _menuCallbacks$.focussedIndex,
    setOpen = _menuCallbacks[1].setOpen,
    _menuCallbacks$2 = _menuCallbacks[2],
    buttonRef = _menuCallbacks$2.buttonRef,
    flyoutRef = _menuCallbacks$2.flyoutRef,
    focussedRef = _menuCallbacks$2.focussedRef,
    containerRef = _menuCallbacks$2.containerRef,
    _menuCallbacks$3 = _menuCallbacks[3],
    onKeyDown = _menuCallbacks$3.onKeyDown,
    handleMouseOver = _menuCallbacks$3.handleMouseOver;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconLinkPresentation, {
    icon: interaction___more02,
    look: "no-text",
    onClick: function onClick() {
      return setOpen(!open);
    },
    id: buttonId,
    expanded: open,
    actionRef: buttonRef,
    onKeyDown: onKeyDown,
    containerRef: containerRef,
    htmlAttrs: {
      "aria-controls": id,
      "aria-haspopup": true
    },
    onMouseHoverChange: onMouseHoverChange,
    onKeyboardFocusChange: onKeyboardFocusChange,
    hasMouseHover: hasMouseHover,
    hasKeyboardFocus: hasKeyboardFocus,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(ActionFlyoutPresentation, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    id: id,
    ariaLabelledBy: buttonId,
    toggleElement: buttonRef.current,
    toggleContainerElement: containerRef.current,
    hostRef: flyoutRef,
    onKeyDown: onKeyDown
  }, navigationTree.map(function (_a, i) {
    var _onClick = _a.onClick,
      label = _a.label,
      item = __rest(_a, ["onClick", "label"]);
    return /*#__PURE__*/React.createElement(ActionFlyoutItemWrapper, Object.assign({}, item, {
      key: i,
      hasKeyboardFocus: i === focussedIndex,
      onClick: function onClick(e, name) {
        setOpen(false);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(e, name);
      },
      onMouseHoverChange: function onMouseHoverChange(isHover) {
        return isHover && handleMouseOver(i);
      },
      actionRef: i === focussedIndex && open ? focussedRef : undefined
    }), label);
  })));
};

export { CardsMenu };
